'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return typeof window === 'undefined' || !!window.SSRtest;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/dist/pure-utils/isServer.js
// module id = 384
// module chunks = 2